"use client";

import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
const MediaQuery = _ref => {
  let {
    media = "(min-width: 0px)",
    defaultMatches = true,
    onChange = () => null,
    render = () => null
  } = _ref;
  const [matches, mediaQuery] = useMediaQuery(onChange, media, defaultMatches);
  return render({
    matches,
    media: mediaQuery
  });
};
MediaQuery.propTypes = {
  /** A media query to use for media matching */
  media: PropTypes.string,
  /** Whether it defaults to matching the `media` or not */
  defaultMatches: PropTypes.bool,
  /** Callback to execute when `media` matching changes are detected */
  onChange: PropTypes.func,
  /** Render prop for conditionally rendering content based on `media` matching */
  render: PropTypes.func
};
export default MediaQuery;
export const useMediaQuery = function (onChange) {
  let media = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "(min-width: 0px)";
  let defaultMatches = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  const [matches, setMatches] = useState(defaultMatches);
  const mql = useRef(null);
  useEffect(() => {
    const update = _ref2 => {
      let {
        matches: updateMatches
      } = _ref2;
      setMatches(updateMatches);
      onChange({
        matches: updateMatches,
        media
      });
    };
    if (window.matchMedia) {
      mql.current = window.matchMedia(media);
      mql.current.addListener(update);
      update(mql.current);
    } else {
      update({
        matches
      });
    }
    return () => {
      var _mql$current;
      mql === null || mql === void 0 ? void 0 : (_mql$current = mql.current) === null || _mql$current === void 0 ? void 0 : _mql$current.removeListener(update);
      mql.current = null;
    };
  }, [matches, media, onChange]);
  return [matches, media];
};